module.exports = __webpack_public_path__ + "static/media/LogoMedpro.84232791.png";